import { render, staticRenderFns } from "./proceed_detail_pc.vue?vue&type=template&id=a9695284&scoped=true&"
import script from "./proceed_detail_pc.vue?vue&type=script&lang=js&"
export * from "./proceed_detail_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9695284",
  null
  
)

export default component.exports